<template>
  <footer class="absolute w-full md:bottom-0  pb-2">
    <div class="container mx-auto px-4">
      <hr class="mb-2 border-b-1 border-gray-500" />
      <div class="flex flex-wrap items-center md:justify-between justify-center">
        <div class="w-full md:w-4/12 px-2">
          <div class="text-sm md:justify-start text-center md:text-left justify-center font-semibold py-1">
            Copyright © {{date}}
            <router-link to="/" rel="external dofollow" class="hover:text-gray-400 text-indigo-400 text-sm font-semibold py-1">Pustaka. </router-link>
            <span class="block text-xs font-light">Made with ❤ in Jakarta  <a href="https://budiardianata.github.io" target="_blank" class="underline">by budi</a> </span>
          </div>
        </div>
        <div class="w-full md:w-8/12 px-4">
          <ul class="flex flex-wrap list-none md:justify-end  justify-center">
            <li v-for="{ id, name } in pages" :key="id" class="hover:text-gray-400 text-indigo-400 text-sm font-semibold block py-1 pl-3">
              <router-link :to="{ name: 'Page', params: { id: id }}">
                {{ name }}
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import {pageList} from "@/firebase";
import {STATE, useSwrCache} from "@/composables/swr-cache";

export default {
  data() {
    return {
      date: new Date().getFullYear()
    }
  },
  setup() {
    const {
      data: pages,
      error,
      state,
    } = useSwrCache('pageList', pageList);
    return { STATE,
      error,
      state,
      pages
    }
  },
}
</script>